import Vue from 'vue'
import Router from 'vue-router'
import {
  getToken,
  getURLParam
} from "@/utils/common";
import Cookies from 'js-cookie'
 
import {
  routers
} from './router'


Vue.use(Router)

export const router = new Router({
  base: process.env.BASE_URL,
  routes: routers,
  // mode: 'history' //hash,history
});
router.beforeEach((to, from, next) => {
  const token = getToken();
  if (token) {
    next()
  } else if (to.path === "/userNotice" || to.path === "/privacyPage" || to.path === "/is_weixn"|| to.path === "/dhShare") {
    next()
  } else {
    let info = getURLParam("token");
    let orgId = getURLParam("orgId");
    Cookies.set("TOKEN_KEY", info);
    Cookies.set("ACCOUNTORG_KEY", orgId);
    next();
  }
})